module.exports = __webpack_public_path__ + "static/media/esa.ddab99ca.png";